/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Typography from '@mui/material/Typography';
import Popover from '@mui/material/Popover';
import InfoIcon from '@mui/icons-material/Info';
import '../../css/CardValue.scss';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import IconButton from '@mui/material/IconButton';
import { enableChangesAtom, showSwitchAtom, openSaveChangesDialogAtom, arrayChangesAtom } from '../Atoms';
import ComplexitySlider from './ComplexitySlider';
import MarkDownBox from './MarkDownBox';

const useStyles = makeStyles({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1vh',
    backgroundColor: '#fff',
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  imgs: {
    width: '25vw',
    height: '20vh',
  },
  goTo: {
    position: 'inherit',
    right: 0,
  },
  btnItem: {
    position: 'inherit',
    right: 0,
    color: 'black',
  },
  slidercard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  areaContainer: {
    marginRight: '8px',
  },
  area: {
    width: '100%',
    fontWeight: '16px',
    font: 'caption',
  },
  cardcontent: {
    '&:last-child': {
      paddingBottom: 0,
    },
    padding: '8px 8px 4px 8px',
  },
  cardheader: {
    paddingBottom: '4px',
  },
});

const CardValue = function ({ Title, Id, sub, valueDefault, setAlert, notes, idNote, Area, backgroundColor }) {
  const classes = useStyles();
  const intl = useIntl();
  const [newValue, setNewValue] = useState(valueDefault);
  const [textValue, setTextValue] = useState(notes);
  const showSwitch = useRecoilValue(showSwitchAtom);
  const enableChanges = useRecoilValue(enableChangesAtom);
  const [openSaveChangesDialog, setOpenSaveChangesDialog] = useRecoilState(openSaveChangesDialogAtom);
  const setArrayChanges = useSetRecoilState(arrayChangesAtom);

  useEffect(() => {
    setTextValue(notes);
  }, [notes]);

  useEffect(() => {
    if (openSaveChangesDialog) {
      const tmpArrayChanges = [];
      if (valueDefault !== newValue) {
        if (textValue === '') {
          setOpenSaveChangesDialog(false);
          setAlert(true);
          setArrayChanges([]);
        } else {
          const s = {
            id: Id,
            title: `${Title}`,
            subtitle: `${sub}`,
            value: newValue,
          };
          const n = {
            id: idNote,
            title: 'Note',
            subtitle: Title,
            value: textValue,
          };
          tmpArrayChanges.push(s);
          tmpArrayChanges.push(n);
          setArrayChanges((oldArray) => [...oldArray, ...tmpArrayChanges]);
        }
      } else if (textValue !== notes && textValue !== '') {
        const n = {
          id: idNote,
          title: 'Note',
          subtitle: Title,
          value: textValue,
        };
        tmpArrayChanges.push(n);
        setArrayChanges((oldArray) => [...oldArray, ...tmpArrayChanges]);
      }
    }
  }, [openSaveChangesDialog]);

  useEffect(() => {
    setNewValue(valueDefault);
  }, [valueDefault]);

  useEffect(() => {
    if (enableChanges && showSwitch) setTextValue('');
    else {
      setNewValue(valueDefault);
      setTextValue(notes);
    }
  }, [showSwitch, enableChanges]);
  const [info, setInfo] = useState(null);

  const openInfo = (event) => {
    setInfo(event.currentTarget);
  };

  const closeInfo = () => {
    setInfo(null);
  };
  const open = Boolean(info);

  const getValueDescription = (value) => {
    if (value < 4) return intl.messages.SHORT_LOW_RATE;
    if (value < 7) return intl.messages.SHORT_MEDIUM_RATE;
    return intl.messages.SHORT_HIGH_RATE;
  };

  return (
    <div>
      <Card
        className={classes.cardContainer}
        style={{ borderColor: backgroundColor, borderStyle: 'solid', borderWidth: '6px' }}
      >
        <CardHeader
          className={classes.cardheader}
          title={
            <div className={classes.title}>
              <Typography color="#bcbcbc" mr={2} variant="h5">
                {sub}
              </Typography>
              <Typography variant="h5">{Title}</Typography>
            </div>
          }
          action={
            <div>
              <IconButton aria-label="info" sx={{ padding: 0 }} onClick={openInfo}>
                <InfoIcon sx={{ color: '#ffffff' }} />
              </IconButton>
              <Popover
                open={open}
                anchorEl={info}
                onClose={closeInfo}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <MarkDownBox text={intl.messages[`${Title}_${Area}_INFO`]} />
              </Popover>
            </div>
          }
          subheader={
            <div>
              <Typography variant="subtitle2" color="#fff" style={{ minHeight: '60px' }}>
                {getValueDescription(newValue)}
              </Typography>
              <div className="slidercard">
                <ComplexitySlider
                  enableChanges={enableChanges}
                  showSwitch={showSwitch}
                  setNewValue={setNewValue}
                  newValue={newValue}
                />
              </div>
            </div>
          }
        />
        <CardContent className={classes.cardcontent}>
          <Typography variant="subtitle2" color="#111">
            {intl.messages.NOTES}
          </Typography>
          <div className={classes.areaContainer}>
            <TextareaAutosize
              className={classes.area}
              minRows={13}
              disabled={!(enableChanges && showSwitch)}
              value={textValue}
              onChange={(e) => {
                setTextValue(e.target.value);
                setAlert(false);
              }}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CardValue;
